/**
 * 奖牌序号列构建器
 * @description 前三名显示奖牌图标（金银铜），其他显示数字序号
 */
import React from 'react';
import ColumnAligner from '@intelligence/v3/components/TableComponents/ColumnAligner';

import TipOne from '@intelligence/assets/svg/tipicon/tip-one.svg';
import TipTwo from '@intelligence/assets/svg/tipicon/tip-two.svg';
import TipThree from '@intelligence/assets/svg/tipicon/tip-three.svg';

import type { TableColumn } from 'tea-component';

import './medalSequence.scss';

// 奖牌图标映射
const MEDAL_ICONS: Record<number, string> = {
  0: TipOne, // 金牌
  1: TipTwo, // 银牌
  2: TipThree, // 铜牌
};

interface IMedalSequenceColumnOption<T> extends Partial<TableColumn<T>> {
  // 获取排名（用于显示奖牌），返回值从0开始
  getRank?: (record: T, index: number) => number;
}

/**
 * 奖牌序号列构建器
 * 前三名显示奖牌图标，其他显示数字序号
 */
const buildMedalSequenceColumn = <T extends IRecord = IRecord>(
  options: IMedalSequenceColumnOption<T> = {},
): TableColumn<T> => {
  const { key = 'medal_sequence', align = 'left', width = 50, getRank, ...rest } = options;

  return {
    ...rest,
    key,
    align,
    width,
    header: '#',
    render: (record, rowKey, recordIndex) => {
      const rank = getRank?.(record, recordIndex) ?? recordIndex;
      const medalIcon = MEDAL_ICONS[rank];

      return (
        <ColumnAligner align={align} width="100%">
          <div className="dbi-medal-sequence">
            {medalIcon ? (
              <img src={medalIcon} alt="" className="dbi-medal-sequence__img" />
            ) : (
              <span className="dbi-medal-sequence__text">{rank + 1}</span>
            )}
          </div>
        </ColumnAligner>
      );
    },
  };
};

export default buildMedalSequenceColumn;
